﻿export class Alert {
    constructor(message, closable = false) {
        this._message = message;
        this.closable = closable;

        this.closable = closable;
        this._alert = document.createElement('div');
        this._alert.classList.add('alert', 'alert-dismissible', 'fade', 'show');
        this._alert.id = 'import-result-alert';
        this._alert.setAttribute('role', 'alert');
        this._alert.innerText = this._message + this._alert.innerText;


        if (this.closable) {
            this._alertClose = document.createElement('button');
            this._alertClose.type = 'button';
            this._alertClose.classList.add('close');
            this._alertClose.setAttribute('data-dismiss', 'alert');
            this._alertClose.setAttribute('aria-label', 'Close');

            this._alertCloseIcon = document.createElement('span');
            this._alertCloseIcon.innerHTML = "&times;";
            this._alertCloseIcon.setAttribute('aria-hidden', 'true');

        this._alertClose.appendChild(this._alertCloseIcon);

        if (this.closable)
            this._alert.appendChild(this._alertClose);
        }
    }

    get() {
        return this._alert;
    };

    appendCloseIcon() {
        if (this.closable) {
            this._alertClose.appendChild(this._alertCloseIcon);
            this._alert.appendChild(this._alertClose);
        }
    }
    clear() {
        this._alert.childNodes.forEach((v, i, p) => {
            v.remove();
        });
        $(this._alert).children().remove();
        this._alert.classList.remove('alert-danger');
        this._alert.classList.remove('alert-primary');
        this._alert.classList.remove('alert-success');
        this._alert.classList.remove('alert-warning');
        this._alert.textContent = '';
        this.appendCloseIcon();

        if (this.closable) {
            this._alertClose.appendChild(this._alertCloseIcon);
            this._alert.appendChild(this._alertClose);

        }
    }

    error(message) {
        this.clear();
        this._alert.classList.add('alert-danger');
        this._message = message;
        this._alert.prepend(this._message);
    };

    message(message) {
        this.clear();
        this._alert.classList.add('alert-primary');
        this._message = message;
        this._alert.prepend(this._message);
    };

    success(message) {
        this.clear();
        this._alert.classList.add('alert-success');
        this._message = message;
        this._alert.prepend(this._message);
    };

    warning(message) {
        this.clear();
        this._alert.classList.add('alert-warning');
        this._message = message;
        this._alert.prepend(this._message);
    };

};